export const CONSTANTS = {
  Edit: 'Редагувати',
  Delete: 'Деактивувати',
};
